// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ChurnLeadRejection_modalWrapper__i0d6T"};